export interface Country {
  code: string
  name: string
  dialCode: string
  flag: string
}

// Base country data without translations
export interface CountryData {
  code: string
  nameKey: `countries.${string}`
  dialCode: string
  flag: string
}

export type CountryNameKey = (typeof countryData)[number]['nameKey']

export type CountryTranslator = (
  key: CountryNameKey,
  values?: { defaultValue?: string },
) => string

export const countryData = [
  { code: 'ES', nameKey: 'countries.spain', dialCode: '+34', flag: '🇪🇸' },
  { code: 'AD', nameKey: 'countries.andorra', dialCode: '+376', flag: '🇦🇩' },
  { code: 'FR', nameKey: 'countries.france', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', nameKey: 'countries.germany', dialCode: '+49', flag: '🇩🇪' },
  { code: 'IT', nameKey: 'countries.italy', dialCode: '+39', flag: '🇮🇹' },
  { code: 'PT', nameKey: 'countries.portugal', dialCode: '+351', flag: '🇵🇹' },
  {
    code: 'GB',
    nameKey: 'countries.unitedKingdom',
    dialCode: '+44',
    flag: '🇬🇧',
  },
  { code: 'US', nameKey: 'countries.unitedStates', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', nameKey: 'countries.canada', dialCode: '+1', flag: '🇨🇦' },
  { code: 'MX', nameKey: 'countries.mexico', dialCode: '+52', flag: '🇲🇽' },
  { code: 'AR', nameKey: 'countries.argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'BR', nameKey: 'countries.brazil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'CL', nameKey: 'countries.chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', nameKey: 'countries.colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'PE', nameKey: 'countries.peru', dialCode: '+51', flag: '🇵🇪' },
  { code: 'UY', nameKey: 'countries.uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'VE', nameKey: 'countries.venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'EC', nameKey: 'countries.ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'BO', nameKey: 'countries.bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'PY', nameKey: 'countries.paraguay', dialCode: '+595', flag: '🇵🇾' },
  { code: 'CR', nameKey: 'countries.costaRica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'PA', nameKey: 'countries.panama', dialCode: '+507', flag: '🇵🇦' },
  { code: 'GT', nameKey: 'countries.guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'HN', nameKey: 'countries.honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'SV', nameKey: 'countries.elSalvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'NI', nameKey: 'countries.nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'CU', nameKey: 'countries.cuba', dialCode: '+53', flag: '🇨🇺' },
  {
    code: 'DO',
    nameKey: 'countries.dominicanRepublic',
    dialCode: '+1',
    flag: '🇩🇴',
  },
  { code: 'PR', nameKey: 'countries.puertoRico', dialCode: '+1', flag: '🇵🇷' },
  { code: 'JP', nameKey: 'countries.japan', dialCode: '+81', flag: '🇯🇵' },
  { code: 'CN', nameKey: 'countries.china', dialCode: '+86', flag: '🇨🇳' },
  { code: 'KR', nameKey: 'countries.southKorea', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', nameKey: 'countries.india', dialCode: '+91', flag: '🇮🇳' },
  { code: 'AU', nameKey: 'countries.australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', nameKey: 'countries.newZealand', dialCode: '+64', flag: '🇳🇿' },
  { code: 'ZA', nameKey: 'countries.southAfrica', dialCode: '+27', flag: '🇿🇦' },
  { code: 'EG', nameKey: 'countries.egypt', dialCode: '+20', flag: '🇪🇬' },
  { code: 'MA', nameKey: 'countries.morocco', dialCode: '+212', flag: '🇲🇦' },
  { code: 'NG', nameKey: 'countries.nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'KE', nameKey: 'countries.kenya', dialCode: '+254', flag: '🇰🇪' },
  { code: 'GH', nameKey: 'countries.ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'RU', nameKey: 'countries.russia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'UA', nameKey: 'countries.ukraine', dialCode: '+380', flag: '🇺🇦' },
  { code: 'PL', nameKey: 'countries.poland', dialCode: '+48', flag: '🇵🇱' },
  { code: 'NL', nameKey: 'countries.netherlands', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', nameKey: 'countries.belgium', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', nameKey: 'countries.switzerland', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', nameKey: 'countries.austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', nameKey: 'countries.sweden', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', nameKey: 'countries.norway', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', nameKey: 'countries.denmark', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', nameKey: 'countries.finland', dialCode: '+358', flag: '🇫🇮' },
  { code: 'IS', nameKey: 'countries.iceland', dialCode: '+354', flag: '🇮🇸' },
  { code: 'IE', nameKey: 'countries.ireland', dialCode: '+353', flag: '🇮🇪' },
  { code: 'LU', nameKey: 'countries.luxembourg', dialCode: '+352', flag: '🇱🇺' },
  { code: 'MT', nameKey: 'countries.malta', dialCode: '+356', flag: '🇲🇹' },
  { code: 'CY', nameKey: 'countries.cyprus', dialCode: '+357', flag: '🇨🇾' },
  { code: 'GR', nameKey: 'countries.greece', dialCode: '+30', flag: '🇬🇷' },
  { code: 'TR', nameKey: 'countries.turkey', dialCode: '+90', flag: '🇹🇷' },
  { code: 'IL', nameKey: 'countries.israel', dialCode: '+972', flag: '🇮🇱' },
  {
    code: 'AE',
    nameKey: 'countries.unitedArabEmirates',
    dialCode: '+971',
    flag: '🇦🇪',
  },
  {
    code: 'SA',
    nameKey: 'countries.saudiArabia',
    dialCode: '+966',
    flag: '🇸🇦',
  },
  { code: 'QA', nameKey: 'countries.qatar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'KW', nameKey: 'countries.kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'BH', nameKey: 'countries.bahrain', dialCode: '+973', flag: '🇧🇭' },
  { code: 'OM', nameKey: 'countries.oman', dialCode: '+968', flag: '🇴🇲' },
  { code: 'JO', nameKey: 'countries.jordan', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', nameKey: 'countries.lebanon', dialCode: '+961', flag: '🇱🇧' },
  { code: 'SY', nameKey: 'countries.syria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'IQ', nameKey: 'countries.iraq', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IR', nameKey: 'countries.iran', dialCode: '+98', flag: '🇮🇷' },
  { code: 'AF', nameKey: 'countries.afghanistan', dialCode: '+93', flag: '🇦🇫' },
  { code: 'PK', nameKey: 'countries.pakistan', dialCode: '+92', flag: '🇵🇰' },
  { code: 'BD', nameKey: 'countries.bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'LK', nameKey: 'countries.sriLanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'MM', nameKey: 'countries.myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'TH', nameKey: 'countries.thailand', dialCode: '+66', flag: '🇹🇭' },
  { code: 'VN', nameKey: 'countries.vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'KH', nameKey: 'countries.cambodia', dialCode: '+855', flag: '🇰🇭' },
  { code: 'LA', nameKey: 'countries.laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'MY', nameKey: 'countries.malaysia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'SG', nameKey: 'countries.singapore', dialCode: '+65', flag: '🇸🇬' },
  { code: 'ID', nameKey: 'countries.indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'PH', nameKey: 'countries.philippines', dialCode: '+63', flag: '🇵🇭' },
  { code: 'BN', nameKey: 'countries.brunei', dialCode: '+673', flag: '🇧🇳' },
  { code: 'TW', nameKey: 'countries.taiwan', dialCode: '+886', flag: '🇹🇼' },
  { code: 'HK', nameKey: 'countries.hongKong', dialCode: '+852', flag: '🇭🇰' },
  { code: 'MO', nameKey: 'countries.macau', dialCode: '+853', flag: '🇲🇴' },
  { code: 'MN', nameKey: 'countries.mongolia', dialCode: '+976', flag: '🇲🇳' },
  { code: 'KZ', nameKey: 'countries.kazakhstan', dialCode: '+7', flag: '🇰🇿' },
  { code: 'UZ', nameKey: 'countries.uzbekistan', dialCode: '+998', flag: '🇺🇿' },
  {
    code: 'TM',
    nameKey: 'countries.turkmenistan',
    dialCode: '+993',
    flag: '🇹🇲',
  },
  { code: 'TJ', nameKey: 'countries.tajikistan', dialCode: '+992', flag: '🇹🇯' },
  { code: 'KG', nameKey: 'countries.kyrgyzstan', dialCode: '+996', flag: '🇰🇬' },
  { code: 'GE', nameKey: 'countries.georgia', dialCode: '+995', flag: '🇬🇪' },
  { code: 'AM', nameKey: 'countries.armenia', dialCode: '+374', flag: '🇦🇲' },
  { code: 'AZ', nameKey: 'countries.azerbaijan', dialCode: '+994', flag: '🇦🇿' },
] as const satisfies readonly CountryData[]

// Function to generate countries with translations
export function getCountriesWithTranslations(t: CountryTranslator): Country[] {
  return countryData.map(country => ({
    code: country.code,
    name: t(country.nameKey, { defaultValue: country.nameKey.split('.')[1] }),
    dialCode: country.dialCode,
    flag: country.flag,
  }))
}

export function getCountryByDialCode(
  dialCode: string,
  t: CountryTranslator,
): Country | undefined {
  const countries = getCountriesWithTranslations(t)
  return countries.find(country => country.dialCode === dialCode)
}

export function getCountryByCode(
  code: string,
  t: CountryTranslator,
): Country | undefined {
  const countries = getCountriesWithTranslations(t)
  return countries.find(country => country.code === code)
}

export function getCountryByName(
  name: string,
  t: CountryTranslator,
): Country | undefined {
  const countries = getCountriesWithTranslations(t)
  return countries.find(country => country.name === name)
}

export function getDefaultCountry(t: CountryTranslator): Country {
  const countries = getCountriesWithTranslations(t)
  return countries[0]! // España por defecto - siempre existe
}
